import { useContext } from 'react';
import PropertyReinsurersRowData from './PropertyReinsurersRowData';
import { RatioFormat, DollarFormat, TextFormat } from '../../format';
import styles from './ReinsurersRow.module.css';
import AppContext from '../../../AppContext';
import RowHelmet from '../RowHelmet';
import EnhancedProfilesLink from '../../links/EnhancedProfilesLink';
import ISiteLink from '../../links/ISiteLink';

function rowClassSwitch(rowClass: string = '') {
  if (rowClass === 'TOTAL') {
    return styles.total;
  } else {
    return '';
  }
}

export default function PropertyReinsurersRow({
  rowKey,
  rowClass,
  label,
  benchmark,
  cocode,
  cededPremiums,
  cededPercentOfTotal,
  netReinsPercentOfTotal,
  netReinsRecoverable,
  domicile,
  affiliated,
  groupCode,
  sectionKey
}: PropertyReinsurersRowData) {
  const { showBenchmark, year } = useContext(AppContext);

  return (
    <div
      id={sectionKey ? sectionKey + '-' + rowKey : 'rowKey-' + rowKey}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${rowClassSwitch(
        rowClass
      )}`}>
      <RowHelmet
        label={label}
        rowKey={rowKey}
        isOutsideBenchmark={cededPremiums.outsideBenchmark}
        benchmarkText={benchmark}
      />
      <TextFormat textValue={affiliated} />
      <p className="column_align_right">
        <EnhancedProfilesLink cocode={cocode} year={year} />
      </p>
      <p className="column_align_right">
        <ISiteLink
          relativeUrl={`/common/GroupList?year=${year}&grpcode=${groupCode}`}
          label={groupCode}
        />
      </p>
      <TextFormat textValue={domicile} />
      <DollarFormat {...cededPremiums} />
      <RatioFormat {...cededPercentOfTotal} />
      <DollarFormat {...netReinsRecoverable} />
      <RatioFormat {...netReinsPercentOfTotal} />
      <p></p>
    </div>
  );
}
